import React from 'react';

/**
 * Multi-skill source filter — DISABLED-WITH-TOOLTIP at v1 per parked
 * decision #3 (N=1 source skill = cyber-agent today; Phase 6.x security
 * skills not yet commissioned). UI present from day one so the multi-skill
 * filter shape is part of the dashboard's mental model.
 */
export function MultiSkillFilter(): React.JSX.Element {
  const tooltip =
    'Multi-skill filtering activates when Phase 6.x security skills commission ' +
    '(intrusion-detection-agent, ai-guardian-agent, tenant-data-guardian-agent, ' +
    'incident-response-agent). Currently filtering by cyber-agent.';
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
      <label
        htmlFor="multi-skill-filter"
        style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}
      >
        Source skill:
      </label>
      <select
        id="multi-skill-filter"
        disabled
        aria-disabled="true"
        aria-describedby="multi-skill-filter-help"
        title={tooltip}
        value="cyber-agent"
        onChange={() => undefined}
        style={{
          padding: '0.25rem 0.5rem',
          borderRadius: '0.25rem',
          border: '1px solid var(--border-default)',
          background: 'var(--surface-disabled, var(--bg-secondary))',
          color: 'var(--text-disabled, var(--text-secondary))',
          cursor: 'not-allowed',
        }}
      >
        <option value="cyber-agent">cyber-agent</option>
      </select>
      <span
        id="multi-skill-filter-help"
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0,0,0,0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        {tooltip}
      </span>
    </div>
  );
}
